module.exports = __webpack_public_path__ + "img/elec_inner_pic6.38f65084.png";